import { CustomSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/types';
import { createImageSlide } from 'sections/welcomeAnim/costumeVariations/mediaCarousel/carouselSlide.util';

export const SnowItems: CustomSlide[] = [
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/snow/snow1%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/snow/snow2%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/snow/snow3%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/snow/snow4%401x.png'
    ),
    createImageSlide(
        'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/snow/snow5%401x.png'
    ),
];
